import { onViewLoad } from "../on_view_load.js";
import { initializeVisibilityToggle, updateVisibility } from "./shared/toggle_visibility.js";

const PREFS_KEY = "production_plans_hide_recipe_search";

const getHideRecipeSearch = (planId) => {
  try {
    const prefs = JSON.parse(localStorage.getItem(PREFS_KEY) || "{}");
    return prefs[planId] || false;
  } catch (e) {
    console.error(e);
    return false;
  }
};

const setHideRecipeSearch = (planId, shouldHide) => {
  try {
    const prefs = JSON.parse(localStorage.getItem(PREFS_KEY) || "{}");
    prefs[planId] = shouldHide;
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch (e) {
    console.error(e);
  }
};

const syncDocumentClass = (visible) => {
  document.documentElement.classList.toggle("recipe-search-hidden", !visible);
};

onViewLoad("production_plans#edit", () => {
  const container = document.querySelector("[data-plan-id]");
  if (!container) return;

  const planId = container.getAttribute("data-plan-id");

  const restoreVisibilityState = () => {
    const currentContainer = document.querySelector("[data-plan-id]");
    const isRecordEmpty = currentContainer?.getAttribute("data-record-is-empty") === "true";
    const userWantsHidden = getHideRecipeSearch(planId);

    const shouldBeVisible = isRecordEmpty || !userWantsHidden;

    const finalVisibility = updateVisibility(shouldBeVisible);
    syncDocumentClass(finalVisibility);
  };

  const onUserVisibilityChange = (visible) => {
    setHideRecipeSearch(planId, !visible);
    syncDocumentClass(visible);
  };

  initializeVisibilityToggle(onUserVisibilityChange);

  restoreVisibilityState();

  document.addEventListener("partial:replace", restoreVisibilityState);
});

onViewLoad("production_plans#new_runs", () => {
  // Parent -> Child toggle
  // [data-toggles=$GROUP] -> [data-toggled-by-$GROUP]
  const toggles = document.querySelectorAll("[data-toggles]");
  toggles.forEach((toggle) => {
    const toggleFor = toggle.dataset["toggles"];

    toggle.addEventListener("click", (_ev) => {
      const checkboxSelector = `input[type='checkbox'][data-toggled-by-${toggleFor}]`;
      document.querySelectorAll(checkboxSelector).forEach((e) => (e.checked = toggle.checked));
    });
  });

  const selectAll = document.querySelector("[data-toggles=select-all]");
  if (!selectAll) {
    return;
  }

  const checkboxSelector = `input[type='checkbox'][data-toggled-by-select-all]`;
  document.querySelectorAll(checkboxSelector).forEach((e) =>
    e.addEventListener("click", () => {
      if (e.checked) {
        const unchecked = document.querySelector(checkboxSelector + ":not(:checked)");
        if (!unchecked) {
          selectAll.checked = true;
        }
      } else {
        selectAll.checked = false;
      }
    })
  );
});
